import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import { DictionaryService } from '@cawita/core-front';
import { CWT_API_CONFIG, CWT_CUSTOM_ERROR_HANDLER_HEADER, CwtApiService } from '@cawita/core-front/api';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CwtSnackbarService } from '../commons/snackbar.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        @Inject(CWT_API_CONFIG) private api: CwtApiService,
        private injector: Injector,
        private dictionary: DictionaryService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.startsWith(this.api.apiUrl)) return next.handle(req);
        const snack = this.injector.get(CwtSnackbarService);
        const snackbarConfig = { duration: 5000 };

        if (!!snack && !req.headers.has(CWT_CUSTOM_ERROR_HANDLER_HEADER.toLowerCase())) {
            return next.handle(req).pipe(catchError((e: HttpErrorResponse) => {
                if (e.status === 0) {
                    snack.error('notification.connection-lost', snackbarConfig);
                } else {
                    snack.error(this.dictionary.translate(e?.error?.translations, 'notification.error-occured'), snackbarConfig);
                }
                throw e;
            }));
        }

        return next.handle(req.clone({
            headers: req.headers.delete(CWT_CUSTOM_ERROR_HANDLER_HEADER.toLowerCase())
        }));
    }
}
